import { ARTICLE_HASH } from "@coworker/app/src/components/TestBuy/constants";

/**
 * Returns the translation key for a testbuy strategy.
 */
export function getStrategyTranslationKey(strategy: string): string {
  const article = Object.values(ARTICLE_HASH).find(
    (article) => article?.type === strategy
  );
  return article?.transKey ?? `${strategy.toLowerCase()}String`;
}
